import React from 'react';
import PropTypes from 'prop-types';
import Button from 'material-ui/Button';
import withStyles from 'material-ui/styles/withStyles';
import ArrowBackIcon from 'material-ui-icons/ArrowBack';
import styles from './styles';

const Header = props => {
	const {
		title, classes, handleGoBack, isHomepage, hideControls
	} = props;

	return (
		<header className={classes.container}>
			{!hideControls && (
				<Button
					color="contrast"
					className={classes.back}
					onClick={handleGoBack}
					disabled={isHomepage}
				>
					<ArrowBackIcon/>
				</Button>
			)}
			<h1 className={classes.title}>{title}</h1>
		</header>
	);
};

Header.propTypes = {
	classes: PropTypes.object.isRequired,
	isHomepage: PropTypes.bool.isRequired,
	hideControls: PropTypes.bool,
	title: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.element
	]),
	handleGoBack: PropTypes.func.isRequired
};

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/client/components/main/header/header.jsx